module.exports = __webpack_public_path__ + "media/avio_intro_veloce.9e5e906b.mp4";